export default "__VITE_ASSET__CfrnqqVi__"